import { Card } from '@/components/Card'
import { Container } from '@/components/Container'
import WalkMiningWebApi from '@/util/client/WalkMiningWebApiConnector'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Link from 'next/link'
import { useRouter } from 'next/router'

function Article({ article }: { article: any }) {
  const route = useRouter()

  return (
    // @ts-ignore
    <Card as="article">
      <Card.Title href={`/notice/detail?id=${article.id}${route.query.ref ? `&ref=${route.query.ref}` : ''}`}>
        {article.title}{' '}
        {article.isNew ? (
          <span className="text-[10px] text-gray-700 bg-blue-100 dark:text-blue-500 rounded-full px-1 py-[2px] ml-1">
            New
          </span>
        ) : (
          ''
        )}
      </Card.Title>
      {/* @ts-ignore */}
      <Card.Eyebrow as="time" decorate>
        {article.createdAt}(UTC)
      </Card.Eyebrow>
      {article?.description && <Card.Description>{article?.description}</Card.Description>}
    </Card>
  )
}

export default function noticePage({ articles }: { articles: any[]; locale: string }) {
  const { t } = useTranslation('translation')
  return (
    <>
      <div className="mb-14 mt-6 flex justify-center">
        <Link href={'/'}>
          <img
            src={`/assets/images/logo/walkmining_logo_b.svg`}
            className={`h-[40px] w-auto lg:h-[55px]`}
            alt={`walkmining`}
          />
        </Link>
        <span className="pl-1 text-[12px] text-gray-500">{t('about_notice_title')}</span>
      </div>
      {/* @ts-ignore */}
      <Container>
        <div className="mx-auto mt-10 max-w-xl gap-y-20 lg:max-w-none">
          <div className="flex flex-col gap-9">
            {articles && articles.length > 0 ? (
              articles.map((article) => <Article key={article.id} article={article} />)
            ) : (
              <div className="text-center">Coming</div>
            )}
          </div>
        </div>
      </Container>
    </>
  )
}

export async function getServerSideProps(ctx: any) {
  const isSSR = ctx.req !== null && ctx.req !== undefined

  const response = await WalkMiningWebApi.getNotices(ctx.locale || 'en', isSSR)
  var articles = null
  if (response) {
    articles = response
  }

  return {
    props: {
      isSSR,
      articles: articles || [],
      locale: ctx.locale || 'en',
      ...(await serverSideTranslations(ctx.locale, ['translation'])),
    },
  }
}
